<template>
    <slot></slot>
</template>

<script>

import ScrollsToTarget from "../../Mixins/ScrollsToTarget.js";

export default {

    name: 'Tabs',

    mixins: [ScrollsToTarget],

    props: {
        reference: {
            type: String,
            default: 'main',
        },
    },

    data() {
        return {
            isScrolling: false,
            targetTab: null,
            targetReference: null,
            targetSection: null,
            isOpen: false,
            isHidden: false,
            tabOffset: 80,
        }
    },

    created() {

    },

    mounted() {

        this.Bus.on('activate-tab', (reference) => {
            this.activateTarget(reference);
        });

        this.Bus.on('scroll-to-reviews', () => {
            this.activateTarget('reviews');
        });

        window.addEventListener('scroll', this.triggerUpdate, supportsPassive() ? { passive: true } : false);

        this.$nextTick(() => {
            this.initTab(this.reference);
            this.setSticky();
        })
    },

    methods: {

        triggerUpdate(event){
            this.setSticky();
            this.detectPositions(event)
        },

        detectPositions(event) {

            let sectionsWithTabReference = document.querySelectorAll('section[data-section-reference]');
            let activeTab = 'main';

            sectionsWithTabReference.forEach(section => {
                let reference = section.getAttribute('data-section-reference');
                let rectTabSection = section.getBoundingClientRect();
                activeTab = rectTabSection.top <= this.tabOffset ? reference : activeTab;
            });

            if (! this.isScrolling) {
                this.initTab(activeTab);
            }
        },

        setSticky() {

            let stickyTarget = document.getElementById('tabs-target');
            let rectStickyTarget = stickyTarget.getBoundingClientRect();

            let tabsAreSticky = rectStickyTarget.top <= 0;

            //set tabs to sticky
            let tabsContainer = document.querySelector('.tabs-container');
            tabsContainer.classList.remove('active');

            if (tabsAreSticky) {
                tabsContainer.classList.add('active');
                this.Bus.emit('set-tabs-sticky');
            } else {
                this.Bus.emit('unset-tabs-sticky');
            }

            //toggle tabs placeholder
            let tabsPlaceholder = document.querySelector('.tabs-placeholder');

            tabsPlaceholder.classList.remove('active');

            if (tabsAreSticky) {
                tabsPlaceholder.classList.add('active');
            }

            //a sad hack for the sticky price section
            if (rectStickyTarget.top < -480) {
                this.Bus.emit('set-price-section-sticky-height');
            } else {
                this.Bus.emit('unset-price-section-sticky-height');
            }
        },

        initTab(reference) {

            this.targetReference = reference;
            let allTabs = document.querySelectorAll('div.tab');
            this.targetTab = document.querySelector('div.tab[data-section-reference="' + reference +'"]');
            let activeIndicator = document.querySelector('div.active-indicator');

            // Loop through all tabs and remove the "active" class
            allTabs.forEach(tab => {
                tab.classList.remove('active');
            });

            if (this.targetTab) {
                this.targetTab.classList.add('active');

                //make activeIndicator the same width as the active tab and also position it underneath the active tab

                let tabRect = this.targetTab.getBoundingClientRect();
                let wrapperRect = this.targetTab.parentElement.getBoundingClientRect(); // Assuming the parent of tabs is the wrapper
                let indicatorWidth = tabRect.width;
                let indicatorLeft = tabRect.left - wrapperRect.left;

                activeIndicator.classList.remove('opacity-0');
                activeIndicator.classList.add('active');
                activeIndicator.classList.add('opacity-100');
                activeIndicator.style.width = indicatorWidth + 'px';
                activeIndicator.style.left = indicatorLeft + 'px';
            }
        },

        activateTarget(reference) {

            this.initTab(reference);

            this.targetSection = document.querySelector('section[data-section-reference="' + reference +'"]');

            if (this.targetSection) {

                let targetTop = this.targetSection.offsetTop - this.getTabOffset(reference);

                this.isScrolling = true;

                this.scrollTo(targetTop, 500);

                setTimeout(() => {
                    this.isScrolling = false;
                }, 500);
            }
        },

        getTabOffset(reference) {
            return this.tabOffset + (reference === 'main' ? -80 : 0);
        },
    }
};

</script>
